import { Box, Grid, Typography } from '@mui/material';
import img from '../../../../../../app/assets/images/landing/A_Truck_about.jpg';
import '../styles/SectionA.scss';
import { useAppSelector } from '../../../../../../app/redux/hooks';

const SectionA = () => {
  const themes = useAppSelector(state => state.theme.theme);

  const constants = {
    content1: `At  ${
      themes == 'ayka' ? 'Ayka' : 'Yaantrac'
    }, we envision a future where vehicle management is seamlessly integrated into businesses across diverse sectors, revolutionizing the way they operate. Through cutting-edge GPS technology and innovative solutions, we strive to empower organizations to optimize their fleet operations, enhance efficiency, and ensure security.`,
    content2:
      'As an integral component of our fleet management software solution, we provide a user-friendly dashboard. Within this dashboard, users gain access to a live map displaying the current location of vehicles. Additionally, users can access insightful analyses regarding driving duration, idle periods, completed trips, and instances of harsh driving.',
    content3: `With a focus on innovation and user experience, ${
      themes == 'ayka' ? 'Ayka' : 'Yaantrac'
    } offers a comprehensive suite of features designed to optimize fleet operations, enhance efficiency, and ensure security. Our intuitive interface provides real-time insights into vehicle locations, speeds, and performance metrics, enabling you to make informed decisions with ease.`
  };

  return (
    <Box className='section-a' my={2}>
      <Grid container spacing={5}>
        <Grid item md={5} sm={12}>
          <Box component='img' src={img} alt='img' className='section-img' />
        </Grid>
        <Grid item md={7} sm={12} className='content'>
          <Typography component='h6'>{constants.content1}</Typography>
          <Typography component='h6'>{constants.content2}</Typography>
          <Typography component='h6'>{constants.content3}</Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default SectionA;
